import React from 'react';
import { Col, Row, Card, CardBody, CardTitle, CardSubtitle, CardText, CardLink, Button } from 'reactstrap';

const CardXt = props => {

    return (
        <>
        <Card
            style={{
            width: '100%',
            borderRadius: "20px 20px 0px 0px",
            }}
        >
            <img
                alt="Card cap"
                src="https://picsum.photos/318/180"
                width="100%"
                style={{borderRadius: "20px 20px 0px 0px",}}
            />
            <CardBody>
                <h4 className='text-xtorage'>XC-mockup-about.jpg</h4>
                <CardText className="mb-2 text-muted text-xtorage" tag="h6" >
                    Formato: JPG/JPEG
                </CardText>
                <CardText className='text-xtorage'>
                    Fecha de registro: 2022-11-08
                </CardText>

                <Row className="text-center text-xtorage">
                    <Col><CardLink href="#">#mockup</CardLink></Col>
                    <Col><CardLink href="#">#DID</CardLink></Col>
                    <Col><CardLink href="#">#SEO</CardLink></Col>
                </Row>
                
                <Row className="flex justify-content-center mt-2 text-xtorage">
                    <Button className="mx-2 w-25 rounded-pill" style={{backgroundColor: 'transparent', color: 'rgba(0,147,195,1)', border: '2px solid rgba(0,147,195,1)'}}>
                        Borrar
                    </Button>
                    <Button className="mx-2 w-25 rounded-pill" style={{backgroundColor: '#00C2FF', border: 'none'}}>
                        Editar
                    </Button>
                    <Button className="mx-2 w-25 rounded-pill" style={{backgroundColor: 'rgba(133,118,192,1)', border: 'none'}}>
                        Compartir
                    </Button>
                </Row>
            </CardBody>
        </Card>
        </>
    );

}

export default CardXt;